import React from 'react'
import iconFacebook from '../../../assets/img/facebook.png';
import './ButtonSocial.css'

const ButtonSocial = ({
    text = '',
    theme = '',
    isFacebook = false,
    icon = iconFacebook,
    disabled = false,
    onClick = () => { }
}) => {
    return (
        <div className={`button-facebook-content ${isFacebook ? 'facebook' : ''}`} onClick={onClick}>
            <img alt="img" className='icon-button-social' src={icon} />
            <div className={`text-button-social ${isFacebook ? 'facebook' : ''}`}>{text}</div>
        </div>
    )
}

export default ButtonSocial
